import { render, staticRenderFns } from "./ReportServiceScheduleSummaryPage.vue?vue&type=template&id=71f1587d&scoped=true&"
import script from "./ReportServiceScheduleSummaryPage.vue?vue&type=script&lang=js&"
export * from "./ReportServiceScheduleSummaryPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f1587d",
  null
  
)

export default component.exports